import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "ll-practice-area-select tw"
};
import { computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useCustomFieldStore } from '@/services/customFieldStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export default {
  __name: 'LlPracticeAreaSelect',
  props: {
    modelValue: {
      type: [Object, String, Number, null],
      default: null
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    componentClass: {
      type: String,
      default: 'remove-outline'
    },
    placeholder: {
      type: String,
      default: 'Select a Practice Area'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      default: 'practice-area-select'
    },
    searchable: {
      type: Boolean,
      default: false
    },
    autoLoad: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const customFieldStore = useCustomFieldStore();
    const meStore = useMeStore();
    const {
      matterTags
    } = storeToRefs(customFieldStore);
    const {
      me
    } = storeToRefs(meStore);

    // Practice area options from customFieldStore
    const practiceAreaOptions = computed(() => {
      return matterTags.value?.mattertags || [];
    });

    // Check if company uses matter tags
    const usesMatterTags = computed(() => {
      return me.value?.company?.usesMatterTags || false;
    });
    const handleChange = value => {
      emit('update:modelValue', value);
      emit('change', value);
    };

    // Without this the menu opens empty while /me and /mattertags are still in flight.
    const loading = ref(false);
    const {
      handleError
    } = useSnackbarHandler();

    // Auto-load matter tags on mount if enabled
    onMounted(async () => {
      if (!props.autoLoad) return;
      loading.value = !practiceAreaOptions.value.length;
      try {
        await meStore.getMe();
        // Now check if company uses matter tags and load them
        if (usesMatterTags.value) {
          await customFieldStore.listMatterTags();
        }
      } catch (error) {
        handleError(error);
      } finally {
        loading.value = false;
      }
    });

    // Expose for manual loading
    __expose({
      loadPracticeAreas: async () => {
        await customFieldStore.listMatterTags();
      }
    });
    return (_ctx, _cache) => {
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!__props.hideLabel ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass(["py-1 text-sm", __props.labelClass])
      }, _toDisplayString(__props.label || 'Practice Area'), 3)) : _createCommentVNode("", true), _createVNode(_component_v_autocomplete, {
        "model-value": __props.modelValue,
        items: practiceAreaOptions.value,
        density: "compact",
        "item-title": "label",
        "item-value": "id",
        "return-object": __props.returnObject,
        variant: "outlined",
        "hide-details": __props.hideDetails,
        class: _normalizeClass(__props.componentClass),
        placeholder: __props.placeholder,
        clearable: __props.clearable,
        disabled: __props.disabled,
        "data-cy": __props.dataCy,
        searchable: __props.searchable,
        loading: loading.value,
        "no-data-text": loading.value ? 'Loading practice areas…' : 'No practice areas',
        "onUpdate:modelValue": handleChange
      }, null, 8, ["model-value", "items", "return-object", "hide-details", "class", "placeholder", "clearable", "disabled", "data-cy", "searchable", "loading", "no-data-text"])]);
    };
  }
};